/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

/* eslint-disable no-console */
//console.log( 'Hello World! (from sp/main-banner block)' );
/* eslint-enable no-console */
document.addEventListener("DOMContentLoaded", function () {
	const slides = document.getElementsByClassName("sp-main-splide");
	const slidesArr = Array.from(slides);
	//console.log("slides:", slidesArr);
	slidesArr.forEach((e) => {
		var splide = new Splide(e, {
			type: "fade",
			perPage: 1,
			pagination: true,
			arrows: false,
			//direction: 'ttb',
			//height   : '22rem',
			breakpoints: {
				1024: {
					perPage: 1,
				},
			},
			autoplay: true,
			rewind: true,
			//interval: 500,
			speed: 1000,
			pauseOnHover: false
		});
		splide.mount();
	});
})
